var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserMale(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.8398C8 18.6388 12.701 23.3398 18.5 23.3398C24.299 23.3398 29 18.6388 29 12.8398C29 7.04084 24.299 2.33984 18.5 2.33984C12.701 2.33984 8 7.04084 8 12.8398Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.8398C13.49 12.8136 17.993 8.21384 18.5 2.33984C13.01 2.36609 8.507 6.96584 8 12.8398Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29 12.8398C23.51 12.8136 19.007 8.21384 18.5 2.33984C23.99 2.36609 28.493 6.96584 29 12.8398Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2642 22.45C10.4437 23.59 7.45644 26.2277 6.28644 29.5307C5.65194 31.3232 6.96669 33.0085 8.84919 33.2755C10.8719 33.5635 13.9904 33.8402 18.5002 33.8402C23.0099 33.8402 26.1277 33.5627 28.1512 33.2755C30.0337 33.0085 31.3492 31.3232 30.7139 29.5307C29.5439 26.2277 26.5567 23.59 22.7362 22.4507C21.4016 23.039 19.9587 23.3417 18.5002 23.3395C16.9927 23.3395 15.5602 23.0222 14.2642 22.45Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29 12.8398C29 18.6388 24.299 23.3398 18.5 23.3398C12.701 23.3398 8 18.6388 8 12.8398C8 7.04084 12.701 2.33984 18.5 2.33984C24.299 2.33984 29 7.04084 29 12.8398Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2642 22.4512C10.4437 23.5904 7.45644 26.2282 6.28644 29.5312C5.65194 31.3237 6.96669 33.0089 8.84919 33.2767C10.8719 33.5632 13.9897 33.8407 18.5002 33.8407C23.0107 33.8407 26.1277 33.5632 28.1512 33.2767C30.0337 33.0089 31.3492 31.3237 30.7139 29.5312C29.5439 26.2282 26.5567 23.5904 22.7362 22.4512",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29 12.8398C23.201 12.8398 18.5 8.13884 18.5 2.33984C18.5 8.13884 13.799 12.8398 8 12.8398",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 17.7148C20.1875 19.7151 16.8125 19.7151 15.5 17.7148",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 13.5898V13.9648",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.25 13.5898V13.9648",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserMale);
export default __webpack_public_path__ + "static/media/user-male.f5caab7c3ce659e2946f768ddce0e028.svg";
export { ForwardRef as ReactComponent };